import { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";

import { H5 } from "../../../AbstractElements";
import BorderTabs from "../../../CommonElements/BorderTabs";
import FilterSliderModal from "../../../CommonElements/FilterSliderModal";
import StatusDisplay from "../../../CommonElements/StatusDisplay";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import {
  getDomainList,
  getSbuList,
} from "../../../ReduxToolkit/Reducers/MasterSlice";
import { Domain, FY, SBU, Select } from "../../../utils/Constant";
import {
  CDPReportTabs,
  generateLoadFactorFiscalYears,
} from "../../../utils/helper/helper";

import AttritionRateTable from "./AttritionRate";
import CDPGraphType from "./Graph";
import StatisticsReport from "./Statistics";

const CDPReports = () => {
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState("1");
  const [domainListData, setDomainListData] = useState([]);
  const { domainList, sbuList } = useAppSelector(state => state.master);
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [defaultFilterValues, setDefaultFilterValues] = useState({});
  const [sbuFilterList, setSbuFilterList] = useState([]);
  const fyList = generateLoadFactorFiscalYears(100, 100);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    await dispatch(getDomainList());
    await dispatch(getSbuList());
  };

  const handleDone = async (values: { [key: string]: string[] }) => {
    return values;
  };

  const handleClear = async () => {
    setSelectedFilterValues({});
    setDefaultFilterValues({});
  };

  useEffect(() => {
    const domains = [];
    domainList?.domain?.forEach(element => {
      domains.push({
        name: element.id.toString(),
        value: element.domain_name,
        label: element.domain_name,
      });
    });
    setDomainListData(domains);
  }, [domainList]);

  useEffect(() => {
    const sbuData = [];

    sbuList?.sbu?.forEach(item => {
      sbuData.push({
        name: item?.id?.toString(),
        value: item?.name,
        label: item?.name,
      });
    });

    setSbuFilterList(sbuData);
  }, [sbuList]);

  const handleBorderTabClick = tabId => {
    setActiveTab(tabId);
  };

  return (
    <div className="pb-5">
      <Card>
        <CardBody className="d-flex justify-content-between">
          <BorderTabs
            tabs={CDPReportTabs}
            activeTab={activeTab}
            handleTabClick={handleBorderTabClick}
            showCard={false}
          />
          <div className="mt-2 d-flex gap-3">
            <div>
              {activeTab === "1" && (
                <H5 className="mt-1 d-flex gap-3">
                  <StatusDisplay label="Domain" number="Service" />{" "}
                  <StatusDisplay label="FY" number="2024-2025" />{" "}
                  <StatusDisplay label="SBU" number="WEST-SBU" />
                </H5>
              )}
            </div>
            <FilterSliderModal
              dropdowns={[
                {
                  label: Domain,
                  key: "domain",
                  tooltipText: `${Select} ${Domain}`,
                  options: domainListData,
                  isMultiSelect: true,
                },
                {
                  label: FY,
                  key: "fy",
                  tooltipText: `${Select} ${FY}`,
                  options: fyList?.map((item, ind) => {
                    return { name: item, label: item, value: ind?.toString() };
                  }),
                  isMultiSelect: false,
                },
                {
                  label: SBU,
                  key: "sbu",
                  tooltipText: `${Select} ${SBU}`,
                  options: sbuFilterList,
                  isMultiSelect: true,
                  showDrop: activeTab !== "1",
                },
              ]}
              selectedFilterValues={selectedFilterValues}
              defaultFilterValues={defaultFilterValues}
              setSelectedFilterValues={setSelectedFilterValues}
              setDefaultFilterValues={setDefaultFilterValues}
              onDone={handleDone}
              onClear={handleClear}
            />
          </div>
        </CardBody>
      </Card>

      <div>{activeTab === "1" && <CDPGraphType />}</div>
      <div>
        {activeTab === "2" && (
          <Card>
            <CardBody>
              <StatisticsReport />
            </CardBody>
          </Card>
        )}
      </div>
      <div>
        {activeTab === "3" && (
          <Card>
            <CardBody>
              <AttritionRateTable fiscalYear={"2024-25"} />
            </CardBody>
          </Card>
        )}
      </div>
    </div>
  );
};

export default CDPReports;
